import React from 'react';
import Visual2DLayoutManager from './Visual2DLayoutManager';

class TableManagementErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center">
          <p className="text-lg font-medium text-gray-700 mb-2">Something went wrong loading the table layout.</p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const StewardTableManagement: React.FC = () => {
  // The Visual2DLayoutManager will handle role-based permissions internally
  return (
    <TableManagementErrorBoundary>
      <Visual2DLayoutManager />
    </TableManagementErrorBoundary>
  );
};

export default StewardTableManagement;